<template>
  <withTopNav left-text="Número verificado">
    <Form class="p-4 leading-[22px]">
      <h6 class="text-15 pb-[6px]">Número de telefone</h6>
      <PhoneInput v-model.trim="phone" noTip placeholder="Número de telefone" />

      <h6 class="text-15 pb-[6px] mt-4">Senha</h6>
      <PasswordInput v-model="password" placeholder="Por favor, insira a senha" />

      <h6 class="text-15 pb-[6px] mt-4">Código de verificação</h6>
      <PhoneCodeInput
        v-model.trim="phoneCode"
        :phone
        placeholder="Código de verificação"
        @captcha-id-change="handleCaptchaIdChange"/>

      <van-button
        class="mt-10 primaryBtn"
        @click="onSubmit"
        :disabled="!canSubmit"
      >Vincular celular</van-button>
    </Form>
  </withTopNav>
</template>

<script setup lang="ts">
import { phoneBind } from '@/api/phoneSms'
import { encryptPassword } from '@/utils'
import { useUserInfo } from '@/store'
import debounce from 'lodash-es/debounce'
import withTopNav from '@/layouts/withTopNav.vue'
import Form from 'vant/lib/form';
import PhoneInput from '@a/components/FormInput/phoneInput.vue';
import PasswordInput from '@a/components/FormInput/passwordInput.vue';
import PhoneCodeInput from '@a/components/FormInput/phoneCodeInput.vue';

const phone = ref('');
const password = ref('');
const phoneCode = ref('');

const loading = ref(false)
const captchaId = ref<string>('')
const handleCaptchaIdChange = (newCaptchaId: string) => {
  captchaId.value = newCaptchaId
}

const validateMap = ref({
  phone: 0,
  password: 0,
  phoneCode: 0,
})

provide('validateMap', validateMap)

const canSubmit = computed(() => Object.values(validateMap.value).every(item => item === 1))

const onSubmit = debounce(async () => {
  if (!canSubmit) return

  const encryptOldPassword = `RSA_${encryptPassword(password.value)}`
  const params = {
    phone: phone.value,
    password: encryptOldPassword,
    captchaVal: phoneCode.value,
    captchaId: captchaId.value
  }

  loading.value = true
  try {
    const { code } = await phoneBind(params)
    if (code === 200) {
      useUserInfo().updateUserInfo({
        smsVerify: true,
        phoneNumber: phone.value,
      })

      // showToast({
      //   type: 'success',
      //   message: 'successMsg',
      //   onClose: () => {
      //     if (!props.type) {
      //       props.setSuccess?.()
      //       props.setIsOpen?.(false)
      //     } else {
      //       router.back()
      //     }
      //   }
      // })
    }
  } finally {
    loading.value = false
  }
}, 500)
</script>
